import { NgModule, type ModuleWithProviders } from '@angular/core';
import { MetaGuard } from './meta-guard';
import { MetaService } from './meta.service';

@NgModule({
  providers: [MetaGuard, MetaService],
})
export class MetaModule {
  static forRoot(): ModuleWithProviders<MetaModule> {
    return {
      ngModule: MetaModule,
      providers: [MetaGuard, MetaService],
    };
  }
}
